/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  SET_PROPERTIES (state, properties) {
    state.properties = properties
  },
  SET_PROPERTY_TYPES (state, property_types) {
    state.property_types = property_types
  },
  SET_USERLIST (state, user_list) {
    state.restaurantlist = user_list
    localStorage.setItem('restaurantlist', JSON.stringify(user_list))
  },
  SET_USERS_RAW (state, user_list) {
    state.userlists = []
    if (!user_list) {
      state.userlists = []
    } else {
      state.userlists.push(user_list)
    }
  },
  SET_SELECTED_RESTAURANT (state, payload) {
    state.selectedRestaurant = payload
    if (state.currentUser.user_group === 2) {
      state.currentUser = payload

      localStorage.setItem('userInfo', JSON.stringify(payload))
    }
    localStorage.setItem('selectedRestaurant', JSON.stringify(payload))
  },
  SET_RESERVATION_STORE (state, data) {
    state.reservationStore = data
  },
  SET_RESERVATION_TOKEN (state, data) {
    state.reservationToken = data
  },
  SET_CONTENTLIST (state, content_list) {
    state.contents = content_list
  },
  SET_PICKUP_HOURS (state, data) {
    state.pickupHours = data
  },
  SET_PICKUP_HOUR (state, { index, type, val }) {
    state.pickupHours[index][type] = val
  },
  SET_DELIVERY_HOUR (state, { index, type, val }) {
    state.deliveryHours[index][type] = val
  },
  SET_DELIVERY_HOURS (state, data) {
    state.deliveryHours = data
  },
  SET_COMMIT_STATUS (state, val) {
    state.post_commit_status = val
  },
  SET_USER_SAVE (state, user_id) {
    state.saved_user_id = user_id
  },
  SET_PROPERTY_LIST (state, payload) {
    state.propertylist = payload
  },
  SET_SECTION_LIST (state, payload) {
    state.sectionlist = payload
  },
  SET_TOKEN_VALID (state, payload) {
    state.token_valid = payload
  },
  SET_ORDER_BY (state, payload) {
    state.order_by_date = payload
  },
  SET_ORDERS (state, payload) {
    state.orders = payload
  },
  SET_CATERING_ORDERS (state, payload) {
    state.cateringOrders = payload
  },
  SET_CATERING_ORDER_OFFERS (state, payload) {
    state.cateringOrderOffers = payload
  },
  SET_SIZE_LIST (state, payload) {
    state.sizelist = payload
  },
  SET_SIZE_OPTIONS (state, payload) {
    state.sizeOptions = payload
  },
  SET_ORDER_STATUSES (state, payload) {
    state.orderStatuses = payload
  },
  SET_PROFILE (state, payload) {
    state.profile = payload.data
  },
  SET_SIZE_OPTIONS_ITEM (state, payload) {
    switch (payload.type) {
    case 'name':
      state.sizeOptions[payload.index].name = payload.value
      break
    case 'price':
      state.sizeOptions[payload.index].price = payload.value
      break
    case 'order':
      state.sizeOptions[payload.index].order = payload.value
      state.sizeOptions[payload.index].sizeItemId = state.sizeOptions[payload.index].id
      delete state.sizeOptions[payload.index].id
      break
    case 'add':
      state.sizeOptions.push(payload.value)
      break
    case 'delete':
      delete state.sizeOptions.splice(payload.index, 1)
      break
    }
  },
  SET_PRODUCT_LIST (state, payload) {
    state.productlist = payload
  },
  SET_RESERVATION_DATA (state, payload) {
    state.reservationData = payload
  },
  SET_USER (state, payload) {
    // Get Data localStorage
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || state.currentUser

    if (payload.user_group === 2) {
      state.selectedRestaurant = payload
    }
    for (const property of Object.keys(payload)) {
      if (payload[property] !== null) {
        // If some of user property is null - user default property defined in state.AppActiveUser
        state.currentUser[property] = payload[property]

        // Update key in localStorage
        userInfo[property] = payload[property]

        if (property === 'reservation') {
          state.reservationData = payload[property]
          state.reservationStore = state.reservationData.store
          state.reservationToken = state.reservationData.token
        }
      }
    }
    // Store data in localStorage
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  PASS (state, payload) {
    state.pass = payload
  },
  SET_MODIFIER_LIST (state, payload) {
    state.modifierlist = payload
  },
  SET_MODIFIER_ITEMS (state, payload) {
    state.modifieritems = payload
  },
  SET_BOUNDARIES (state, payload) {
    state.boundaries = payload
  },
  SET_COUPONS (state, payload) {
    state.coupons = payload
  },
  SET_MODIFIER_ITEM (state, payload) {
    switch (payload.type) {
    case 'add':
      state.modifieritems.push(payload.value)
      break
    case 'name':
      state.modifieritems[payload.index].name = payload.value
      break
    case 'price':
      state.modifieritems[payload.index].price = payload.value
      break
    case 'delete':
      delete state.modifieritems.splice(payload.index, 1)
      break
    case 'order':
      state.modifieritems[payload.index].order = payload.value
      state.modifieritems[payload.index].modifierItemId = state.modifieritems[payload.index].id
      delete state.modifieritems[payload.index].id
      break
    }
  },
  SET_PROPERTY_ITEM (state, { code, val }) {
    state.propertylist[code] = val
  },
  SET_ORDER_STATUS_CHANGED (state, val) {
    state.orderStatusChanged = val
  },
  SET_CATERING_ORDER_STATUS_CHANGED (state, val) {
    state.cateringOrderStatusChanged = val
  }
}
